/**
 * True when the app is running inside an iframe (e.g. an embedded tour).
 * Wrapped in try/catch because cross-origin embedding throws on `window.top`.
 */
export function isInIframe(): boolean {
  if (typeof window === "undefined") return false;
  try {
    return window.self !== window.top;
  } catch {
    return true;
  }
}

/**
 * Best-effort origin of the page that embedded us (the parent frame).
 * Prefers `ancestorOrigins` (Chromium/WebKit), falls back to the referrer.
 * Returns null when it can't be determined — callers treat null as "unknown".
 */
export function getEmbedderOrigin(): string | null {
  if (typeof window === "undefined") return null;
  try {
    const ao = window.location.ancestorOrigins;
    if (ao && ao.length > 0) return ao[0];
  } catch {
    // ancestorOrigins unsupported — fall through to referrer.
  }
  if (typeof document !== "undefined" && document.referrer) {
    try {
      return new URL(document.referrer).origin;
    } catch {
      return null;
    }
  }
  return null;
}
